const listType = {
  ALL_ACT: 1,
  REPORTABLE_ACT: 2,
  REPORTED_ACT: 3,
  COLLECTION_ACT: 4,
};

const listType_string = {
  ALL_ACT: '1',
  REPORTABLE_ACT: '2',
  REPORTED_ACT: '3',
  COLLECTION_ACT: '4',
};

export { listType, listType_string };
